import React from "react";
import moment from "moment";
import "./ChatItem.scss";

export interface Chat {
  id: string;
  title: string;
  lastMessage?: string;
  lastMessageTime?: Date;
  isActive?: boolean;
}

interface ChatItemProps {
  chat: Chat;
  onClick: () => void;
}

const ChatItem: React.FC<ChatItemProps> = ({ chat, onClick }) => {
  const formatTime = (date?: Date) => {
    if (!date) return "";
    return moment(date).format("MMM D");
  };

  return (
    <div
      className={`chat-item ${chat.isActive ? "chat-item-active" : ""}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
      aria-label={`Chat: ${chat.title}`}
    >
      <div className="chat-item-content">
        <div className="chat-item-title">{chat.title}</div>
        {chat.lastMessage && (
          <div className="chat-item-preview">{chat.lastMessage}</div>
        )}
      </div>
      {chat.lastMessageTime && (
        <div className="chat-item-time">{formatTime(chat.lastMessageTime)}</div>
      )}
    </div>
  );
};

export default ChatItem;

